import VueNotify from './Notify.vue';

export default {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  install(Vue: any, notifyOptions = {}) {
    const Constr = Vue.extend(VueNotify);
    const Notify = new Constr();
    Notify.options = Object.assign(Notify.options, notifyOptions);
    const vm = Notify.$mount();
    (document.querySelector('body') as HTMLBodyElement).appendChild(vm.$el);
    // eslint-disable-next-line no-param-reassign
    Vue.prototype.$notify = {
      show(type = 'success', message: string, title: string, options = {}) {
        Notify.addItem(type, message, title, options);
      },
    };
  },
};
